import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CurrencyData } from '../../_models/currency';
import { Counts } from '../../_models/data';
import { OneUser, UserData } from '../../_models/users';
import { FormBuilder } from '@angular/forms';
import { ApiService } from '../../_services/api.service';
import { ChecksService } from '../../_services/checks.service';
import { NotificationService } from '../../_services/notification.service';

@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrl: './kyc.component.css'
})
export class UserKycComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  
  // userData: UserData;
  page: number = 1;
  count: Counts;

  url = this.router.url.slice(1);

  mainHeader: string = "All KYC Pending Review";
  view: string = "";

  processing: boolean = false;
  loading: boolean = true;

  userist: UserData[] = [];
  currencyList: CurrencyData[] = [];

  edit: boolean = false;
  docTypeName: string = '';
  docTypeRef: number = 0;

  constructor(
    private fb: FormBuilder,
    public checkService: ChecksService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.checkService.checkSession();
    this.getRouteParams();
  }

  ngOnInit(): void {

    if (this.routeParams['view'] !== undefined) {
      this.view = this.routeParams['view'];
      this.mainHeader = "List "+this.view+" Users";
    }

    if (this.queryParams['page'] !== undefined) {
      this.page = this.queryParams['page'];
    } else {
      this.page = 1;
    }
    this.getUserKyc(this.page);
  }

  getUserKyc(page:number) {
    this.loading = true;

    this.apiService.getUserKyc(page, this.view).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.count = data.counts;
          this.userist = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );

  }
  
  getRouteParams() {
    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });

    // URL get change
    this.activatedRoute.url.subscribe(url =>{
      this.ngOnInit();
    });
  }

  printName(details:UserData) {
    return (details.companyDetails.ref == 0)? details.firstName + " " + details.lastName : details.companyDetails.name
  }

}
